module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/banner_app-6ec4c159d422537ef66d38e59cda949a.png";